import React from 'react';
import { Typography, Box } from '@mui/material';

const Declaracao: React.FC = () => {
  return (
    <div className="declaracao-page">
      <Typography variant="h4" component="h1" gutterBottom>
        Declaração
      </Typography>
      <Box>
        <Typography variant="body1">
          Página de declaração em desenvolvimento...
        </Typography>
      </Box>
    </div>
  );
};

export default Declaracao; 